/**
 * Single source of truth for the cross-domain storage bridge.
 *
 * Loaded two ways, so it stays plain ES5 + UMD:
 *   - as a <script> by storage/index.html (exposes window.RESPONA_STORAGE_CONFIG)
 *   - as a CommonJS module by src/utils/crossDomainStorage.ts (webpack)
 *
 * Keep explicit origins only. Never widen this to a *.respona.com wildcard:
 * iframe.respona.com serves third-party HTML and must not be able to talk to storage.
 *
 * Deployment: storage/ is published to storage.respona.com / dev-storage.respona.com
 * out of band. index.html loads this file before storage-service.js, so ship all three
 * files together; the service refuses to start without it.
 */
(function (root, factory) {
  var config = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = config;
  } else {
    root.RESPONA_STORAGE_CONFIG = config;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  return {
    /** Origins (apps) that may read / write through the storage frame. */
    ALLOWED_APP_ORIGINS: [
      'https://respona.com',
      'https://dev.respona.com',
      'https://dev-concierge.respona.com',
      'https://dev-publisher.respona.com',
      'https://app.respona.com',
      'https://dashboard.respona.com',
      'https://publisher.respona.com',
    ],
    /** Origins the storage frame itself is served from (the app only trusts messages from these). */
    STORAGE_ORIGINS: ['https://storage.respona.com', 'https://dev-storage.respona.com'],
    /**
     * Keys that must never leave the origin that created them. The session token is
     * `Authorization` material: fanning it out to other subdomains widens the XSS blast
     * radius to every one of them. Both sides refuse to sync these.
     */
    NON_SYNCABLE_KEYS: ['token', 'refreshToken', 'refresh_token', 'access_token', 'GOD_MODE'],
  };
});
